import { VehicleDetailsDataObject } from '../../services/vehicle-service'

export interface DealerDetails {
  idField: string | null
  nameField: string | null
}

export interface AdvertDetails {
  urlField: string
}

export interface VehicleDetails {
  registrationField: string
  mileageField: number
  makeField: string
  modelField: string
  valueField?: number
  valueSpecifiedField: boolean
  isUsedField: true
  isUsedSpecifiedField: true
  dealerField: DealerDetails | null
  advertField?: AdvertDetails | null
}

export const mapToVehicleDetails = (
  vehiclePrice: number,
  apiObject?: VehicleDetailsDataObject
): VehicleDetails | null => {
  const price = apiObject?.price || apiObject?.value
  if (apiObject?.registration) {
    return {
      registrationField: apiObject.registration,
      mileageField: apiObject.currentMileage
        ?? apiObject.mileage
        ?? 0,
      makeField: apiObject.make || 'unknown',
      modelField: apiObject.model || 'unknown',
      valueField: vehiclePrice,
      valueSpecifiedField: price !== undefined,
      isUsedField: true,
      isUsedSpecifiedField: true,
      dealerField: {
        idField: apiObject.dealerId ? apiObject.dealerId : null,
        nameField: apiObject.dealerName ? decodeURIComponent(apiObject.dealerName) : null
      },
      advertField: apiObject.advertUrl ? {
        urlField: apiObject.advertUrl
      } : null
    }
  }
  return null
}
